import { config as partnersConfig } from './partners.config';
import { config as selectDateConfig } from './select-date.config';
import { config as aboutYouConfig } from './about-you.config';
import { config as completeConfig } from './complete-page.config';
import { config as pathConfig } from './path.config';
import { config as remoteConfig } from './remote.config';
import { config as modeConfig } from './mode.config';
import { config as reviewConfig } from './review.config';
import { PROGRESS_BAR_ITEMS, EDIT_PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import {
  ChosenPartner,
  ADDITIONAL_INFORMATION,
  HAIR_SKIN_EYES,
  SIZES_AND_AGE,
} from '~/components';
import { getAppointmentsDetails } from './analytics.config';
import { createHeadline } from './headline.config';
import { services } from '../../services.constant';

import styles from '~/components/questions/question/Question.scss';

const questionsSectionsConfig = [
  {
    key: SIZES_AND_AGE,
    title: 'Clothing sizes and age range',
    dataTest: 'SizesAndAge',
    description: "Don't worry if you're between sizes. You can select more than one.",
    url: 'clothing-sizes-and-age-range',
  },
  {
    key: HAIR_SKIN_EYES,
    title: 'Hair, skin and eye colour',
    dataTest: 'HairAndEyes',
    extraClassName: styles.HairAndEyeColour,
    url: 'hair-skin-and-eye-colour',
  },
  {
    key: ADDITIONAL_INFORMATION,
    title: 'Additional information',
    dataTest: 'AdditionalInformation',
    url: 'budget-and-additional-information',
  },
];

export const config = {
  ...selectDateConfig,
  ...partnersConfig,
  ...aboutYouConfig,
  ...completeConfig,
  ...pathConfig,
  ...reviewConfig,
  serviceName: services.PERSONAL_STYLING.name,
  PROGRESS_BAR_ITEMS,
  EDIT_PROGRESS_BAR_ITEMS,
  remote: remoteConfig,
  mode: modeConfig,
  chosenPartner: ChosenPartner,
  partnerTitle: 'Personal Stylist',
  partnerPrefix: 'Partner & ',
  defaultPartnerText: 'I don\'t mind which Personal Stylist I use',
  getAppointmentsDetails,
  isPartnerSelectionEnabled: true,
  questionsSectionsConfig,
  headlineTitle: createHeadline,
};
